import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import { UploadFileLink } from '@/components/ui/Form/UploadFile/UploadFileLink';
/**
 * アップロードファイルを表示するためのリンクコンポーネント
 * @description 特に認証などの必要がない通常ファイル表示で使用する想定
 * @param props
 * @constructor
 */
export const UploadFileBlobLink = (props) => {
    const { className = '', file, hasUploadError, isDeletable, isUploading, onClickDelete, textSize, } = props;
    const fileUrl = useMemo(() => URL.createObjectURL(file), [file]);
    useEffect(() => () => {
        URL.revokeObjectURL(fileUrl);
    }, [fileUrl]);
    return (_jsx(UploadFileLink, { className: className, fileLink: fileUrl, fileName: file.name, hasUploadError: hasUploadError, isDeletable: isDeletable, isUploading: isUploading, onClickDelete: onClickDelete, textSize: textSize }));
};
